module.exports = __webpack_public_path__ + "img/icon-pushpin-blue.e5576627.svg";